import { LENGTH_KEY, LOWERED_VERSION_METHOD_KEY, POWER_METHOD_KEY, PRODUCT_OPTIONS_KEY, TRANSMISSION_METHOD_KEY, } from '@yme/selectors/constants';
import { CONTROL_METHOD_KEY, PRICE_KEY, FINAL_PRICE_KEY, PRICING_DISCLAIMER_KEY, PRODUCT_NAME_EXTENDED_KEY, ROTATION_KEY, SHAFT_LENGTH_KEY, SIZE_KEY, STARTING_METHOD_KEY, } from '@yme/selectors/index';
import { HeadingLevel3Styled, HeadingLevel3OldPriceStyled, RegularTextLevel5STyled, HeaderCellStyled, DefaultCellStyled, PriceStyled, } from './styled';
export const DISCLAIMER_EXTRA_ROW = [
    {
        id: PRICING_DISCLAIMER_KEY,
        cell: RegularTextLevel5STyled,
    },
];
const COMMON_WIDTH_CELL = {
    md: 'calc(100% / 6)',
    lg: 'auto',
};
// Common config
export const DEFAULT_TABLE_COLUMNS_CONFIG = [
    {
        id: PRODUCT_NAME_EXTENDED_KEY,
        cellWidth: {
            md: '100%',
            lg: '100%',
        },
        cell: DefaultCellStyled,
    },
    {
        id: PRICE_KEY,
        cell: HeadingLevel3OldPriceStyled,
    },
    {
        id: FINAL_PRICE_KEY,
        cell: HeadingLevel3Styled,
    },
];
// Config for EBIKES
// Table Head config
export const TABLE_COLUMNS_EBIKES_CONFIG = [
    {
        id: SIZE_KEY,
        cellWidth: {
            md: '100%',
            lg: '100%',
        },
        cell: DefaultCellStyled,
    },
    {
        id: PRICE_KEY,
        cell: HeadingLevel3OldPriceStyled,
    },
    {
        id: FINAL_PRICE_KEY,
        cell: HeadingLevel3Styled,
    },
];
// Table Body config
export const THEAD_COLUMNS_EBIKES_CONFIG = [
    {
        id: SIZE_KEY,
        cellWidth: {
            md: '100%',
            lg: '100%',
        },
        cell: HeaderCellStyled,
    },
    {
        id: PRICE_KEY,
        cell: HeadingLevel3OldPriceStyled,
    },
    {
        id: FINAL_PRICE_KEY,
        cell: HeadingLevel3Styled,
    },
];
// Configs for BOATS
// Table Head config
export const THEAD_COLUMNS_BOATS_CONFIG = [
    {
        id: LENGTH_KEY,
        cellWidth: {
            md: '100%',
            lg: '100%',
        },
        cell: HeaderCellStyled,
    },
    {
        id: PRICE_KEY,
        cell: HeadingLevel3OldPriceStyled,
    },
    {
        id: FINAL_PRICE_KEY,
        cell: HeadingLevel3Styled,
    },
];
// Table Body config
export const BOATS_TABLE_COLUMNS_CONFIG = [
    {
        id: LENGTH_KEY,
        cellWidth: {
            md: '100%',
            lg: '100%',
        },
        cell: DefaultCellStyled,
    },
    {
        id: PRICE_KEY,
        cell: HeadingLevel3OldPriceStyled,
    },
    {
        id: FINAL_PRICE_KEY,
        cell: HeadingLevel3Styled,
    },
];
// Configs for SCOOTERS
// Table Head config
export const THEAD_COLUMNS_SCOOTERS_CONFIG = [
    {
        id: PRODUCT_OPTIONS_KEY,
        cellWidth: {
            md: '100%',
            lg: '100%',
        },
        cell: HeaderCellStyled,
    },
    {
        id: PRICE_KEY,
        cell: HeadingLevel3OldPriceStyled,
    },
    {
        id: FINAL_PRICE_KEY,
        cell: HeadingLevel3Styled,
    },
];
// Table Body config
export const SCOOTERS_TABLE_COLUMNS_CONFIG = [
    {
        id: PRODUCT_OPTIONS_KEY,
        cellWidth: {
            md: '100%',
            lg: '100%',
        },
        cell: DefaultCellStyled,
    },
    {
        id: PRICE_KEY,
        cell: HeadingLevel3OldPriceStyled,
    },
    {
        id: FINAL_PRICE_KEY,
        cell: HeadingLevel3Styled,
    },
];
// Configs for MARINE ENGINES
// Table Head config
export const THEAD_COLUMNS_MARINE_ENGINE_CONFIG = [
    {
        id: ROTATION_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeaderCellStyled,
    },
    {
        id: SHAFT_LENGTH_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeaderCellStyled,
    },
    {
        id: STARTING_METHOD_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeaderCellStyled,
    },
    {
        id: CONTROL_METHOD_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeaderCellStyled,
    },
    {
        id: PRICE_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeaderCellStyled,
    },
    {
        id: FINAL_PRICE_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeaderCellStyled,
    },
];
// Table Body config
export const MARINE_ENGINES_TABLE_COLUMNS_CONFIG = [
    {
        id: ROTATION_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: DefaultCellStyled,
    },
    {
        id: SHAFT_LENGTH_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: DefaultCellStyled,
    },
    {
        id: STARTING_METHOD_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: DefaultCellStyled,
    },
    {
        id: CONTROL_METHOD_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: DefaultCellStyled,
    },
    {
        id: PRICE_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeadingLevel3OldPriceStyled,
    },
    {
        id: FINAL_PRICE_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: PriceStyled,
    },
];
export const THEAD_COLUMNS_MOTORCYCLES_CONFIG = [
    {
        id: POWER_METHOD_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeaderCellStyled,
    },
    {
        id: TRANSMISSION_METHOD_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeaderCellStyled,
    },
    {
        id: LOWERED_VERSION_METHOD_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeaderCellStyled,
    },
    {
        id: PRICE_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeaderCellStyled,
    },
    {
        id: FINAL_PRICE_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeaderCellStyled,
    },
];
export const MOTORCYCLES_TABLE_COLUMNS_CONFIG = [
    {
        id: POWER_METHOD_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: DefaultCellStyled,
    },
    {
        id: TRANSMISSION_METHOD_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: DefaultCellStyled,
    },
    {
        id: LOWERED_VERSION_METHOD_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: DefaultCellStyled,
    },
    {
        id: PRICE_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: HeadingLevel3OldPriceStyled,
    },
    {
        id: FINAL_PRICE_KEY,
        cellWidth: COMMON_WIDTH_CELL,
        cell: PriceStyled,
    },
];
